module.exports = __webpack_public_path__ + "img/wii-fit.84355e48.png";